var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBag = function SvgBag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m16.957 15.19-1.996-7.98c-.11-.411-.465-.711-.847-.711h-1.64c.082-.247.136-.547.136-.876A2.61 2.61 0 0 0 9.988 3a2.625 2.625 0 0 0-2.624 2.622c0 .329.055.602.136.876H5.887c-.382 0-.738.3-.847.71L3.044 15.19c-.219.93.41 1.804 1.257 1.804h11.371c.875 0 1.503-.875 1.284-1.804zM10.014 6.5a.887.887 0 0 1-.902-.876c0-.465.41-.874.902-.874.465 0 .875.41.875.874a.88.88 0 0 1-.875.876"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBag);
export default ForwardRef;